import axios from "axios";

/**
 * Cliente compartido de axios para todos los servicios de minute-a-minute
 * Centraliza la configuración base, timeout, headers, etc.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://dev-api.amxinfra.com";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Interceptor para errores globales (opcional, para future logging)
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.message);
    throw error;
  }
);
